module.exports = __webpack_public_path__ + "static/media/red_social.7018247b.png";